import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ArrowIcon,
  FooterLink,
  LinkStyled,
  LinkText,
} from './TrlFooterLink.styles';

export const TrlFooterLink = ({
  href,
  navigateTo,
  label,
  hasMarginTop,
  hasBorder,
  atTheBottom,
  backgroundColor,
  height,
  justifyContent,
  fontSize,
  isTextBold,
  hasArrow,
  borderRadius,
}) => (
  <FooterLink
    hasMarginTop={hasMarginTop}
    hasBorder={hasBorder}
    atTheBottom={atTheBottom}
    backgroundColor={backgroundColor}
    height={height}
    justifyContent={justifyContent}
    borderRadius={borderRadius}
  >
    <LinkStyled
      href={href}
      onClick={navigateTo}
      target="_blank"
      underline="none"
    >
      <LinkText fontSize={fontSize} isTextBold={isTextBold}>
        <FormattedMessage id={label} />
      </LinkText>
      {hasArrow && <ArrowIcon icon={faCaretRight} />}
    </LinkStyled>
  </FooterLink>
);

TrlFooterLink.propTypes = {
  href: PropTypes.string,
  navigateTo: PropTypes.func,
  label: PropTypes.string.isRequired,
  hasMarginTop: PropTypes.bool,
  hasBorder: PropTypes.bool,
  atTheBottom: PropTypes.bool,
  backgroundColor: PropTypes.string.isRequired,
  height: PropTypes.string,
  justifyContent: PropTypes.string,
  fontSize: PropTypes.string,
  isTextBold: PropTypes.bool,
  hasArrow: PropTypes.bool,
  borderRadius: PropTypes.string,
};
